import * as z from "zod/v4";

export const NotionProductKnowledgeEditEventType = z.enum([
  "content_updated",
  "created",
  "deleted",
  "undeleted",
  "moved",
  "properties_updated",
  "locked",
  "unlocked",
]);

export const NotionProductKnowledgeEditSummary = z.object({
  id: z.string(),
  notionEventId: z.string(),
  notionPageId: z.string(),
  eventType: NotionProductKnowledgeEditEventType,
  editedByNotionUserId: z.string().nullable(),
  editedByName: z.string().nullable(),
  editedAt: z.date(),
  title: z.string().nullable(),
  productArea: z.string().nullable(),
  linesAdded: z.number(),
  linesRemoved: z.number(),
  syncedAt: z.date().nullable(),
  createdAt: z.date(),
});

export const listProductKnowledgeEdits = {
  name: "listProductKnowledgeEdits" as const,
  input: z.object({
    editedByNotionUserId: z.string().optional(),
    productArea: z.string().optional(),
    eventType: NotionProductKnowledgeEditEventType.optional(),
    editedAt: z.tuple([z.date().nullable(), z.date().nullable()]).optional(),
    notionPageId: z.string().optional(),
    offset: z.number().optional(),
    limit: z.number().optional(),
  }),
  output: z.object({
    edits: z.array(NotionProductKnowledgeEditSummary),
    nextOffset: z.number().nullable(),
  }),
};
